module.exports = __webpack_public_path__ + "static/img/zt5888337.fc8ff957.png";